import { ReactNode } from "react";

export default function Container({ className, id, children }: { className?: string, id?: string, children: ReactNode }){
  return <div id={id || ""} className={`page-pl page-pr ${className || ""}`}>{children}</div>;
};
